/** @file A skin's entries: re-point an attachment, remove a mapping, add one (skin.setEntry / removeEntry). */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { Button } from '../../ui-kit/Button';
import { Select } from '../../ui-kit/Select';
import type { RunCommands } from '../rigKit/rigView';
import { AddSkinEntry } from './AddSkinEntry';
import { skinEntryRows } from './skinEntryRows';

/** Props of SkinEntries; `skin` is the selected skin's id. */
export interface SkinEntriesProps {
  doc: Doc;
  t: Translate;
  run: RunCommands;
  skin: Id;
}

/** Every row's attachment is a Select over all attachments by name. */
export function SkinEntries({ doc, t, run, skin }: SkinEntriesProps) {
  const attachments = entriesByName(doc.attachments).map(([value, a]) => ({ value, label: a.name }));
  const setEntry = (slot: Id, placeholder: string, attachment: Id): void => { run([{ name: 'skin.setEntry', input: { skin, slot, placeholder, attachment } }]); };
  const removeEntry = (slot: Id, placeholder: string): void => { run([{ name: 'skin.removeEntry', input: { skin, slot, placeholder } }]); };
  return (
    <fieldset className="rig-fields">
      <legend>{t('panels.skins.entries')}</legend>
      <ul aria-label={t('panels.skins.entries')}>
        {skinEntryRows(doc, skin).map((r) => (
          <li key={`${r.slot}/${r.placeholder}`} className="rig-row">
            {`${r.slotName} / ${r.placeholder}`}
            <Select label={t('panels.skins.attachment')} value={r.attachment} options={attachments} onChange={(id) => { setEntry(r.slot, r.placeholder, id); }} />
            <Button label={t('panels.skins.remove')} onClick={() => { removeEntry(r.slot, r.placeholder); }} />
          </li>
        ))}
      </ul>
      <AddSkinEntry doc={doc} t={t} attachments={attachments} onAdd={setEntry} />
    </fieldset>
  );
}
